import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from "./components/pages/home/home.component";
import {AboutComponent} from "./components/pages/about-us/about-us.component";
import {ServicesComponent} from "./components/pages/services/services.component";
import {ProductsGrcComponent} from "./components/pages/products-grc/products-grc.component";
import {
  ProductsPhishingSimulationComponent
} from "./components/pages/products-phishing-simulation/products-phishing-simulation.component";
import {ProductsPhishingComponent} from "./components/pages/products-phishing/products-phishing.component";
import {BlogsComponent} from "./components/pages/blogs/blogs.component";
import {BlogsDetailsComponent} from "./components/pages/blogs-details/blogs-details.component";
import {ContactUsComponent} from "./components/pages/contact-us/contact-us.component";
import { PartnerComponent } from './components/pages/partner/partner.component';
import {TermsComponent} from "./components/pages/terms/terms.component";
import { CookiePolicyComponent } from './components/pages/cookie-policy/cookie-policy.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { AwarenessPostersComponent } from './components/pages/awareness-posters/awareness-posters.component';


  const routes: Routes = [
    {
      path: '',
      children: [
        { path: '', component: HomeComponent },
        { path: 'about-us', component: AboutComponent },
        { path: 'services/:id', component: ServicesComponent },
        { path: 'services', component: ServicesComponent },
        { path: 'products-grc', component: ProductsGrcComponent },
        { path: 'products-phishing-simulation', component: ProductsPhishingSimulationComponent },
        { path: 'products-awareness', component: ProductsPhishingComponent },
        { path: 'blogs', component: BlogsComponent },
        { path: 'blogs-details/:id', component: BlogsDetailsComponent },
        { path: 'contact-us', component: ContactUsComponent },
        { path: 'partner', component: PartnerComponent },
        { path: 'terms-and-conditions', component: TermsComponent },
        { path: 'cookie-policy', component: CookiePolicyComponent },
        { path: 'privacy-policy', component: PrivacyPolicyComponent },
        { path: 'awareness-posters', component: AwarenessPostersComponent },

      ]

    }
  ];

  @NgModule({
    imports: [RouterModule.forRoot(routes), RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule],
  })
  export class AppRoutingModule { }





